// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3VBpK","signatureBlock":"Footer_signatureBlock__1hQEX","signature":"Footer_signature__1E2FX"};